export const environment = {
  production: true,
  env: 'dev',
  default_schema: '',
  version: 'v1.4.12',
  baseURL: 'https://devjecrm.com/api',
  socketURL: 'https://devjecrm.com/api/ws',
  web_url: 'dev.jecrm.org',
  login_url: 'https://auth.devjecrm.com/login',
  registration_url: 'https://auth.devjecrm.com/register',
  levelSubdomain: 3,
  specialDomains: [
    'dev',
    'demo',
    'api',
    'dev-api',
    'demo-api',
    'sso',
    'dev-sso',
    'demo-sso',
    'tb',
    'dev-tb',
    'demo-tb',
  ],
};
